import React from "react";
import { Link } from "react-router-dom";
const jobs = [
  {
    id: "01",
    title: "Analyst – Debt Advisory",
    description:
      "Support transaction structuring, credit analysis, and lender presentations for debt mandates across sectors.",
    tags: ["Finance Graduate", "0–3 Years", "Full-Time"],
  },
  {
    id: "02",
    title: "Associate – Equity & Fundraising",
    description:
      "Work on equity fundraising mandates, investor outreach, and financial modelling for growth-stage and mid-market companies.",
    tags: ["MBA / CA", "2–5 Years", "Full-Time"],
  },
  {
    id: "03",
    title: "Business Development Manager",
    description:
      "Identify and onboard new mandates, build client relationships, and expand the company's presence across regions and sectors.",
    tags: ["Any Background", "3+ Years", "Full-Time"],
  },
];

export default function CareerSection() {
  return (
    <section className=" py-20" id="careers">
      <div className="mx-auto max-w-7xl px-6">
        {/* Header */}
        <div className="max-w-3xl">
          <p className="text-xs font-semibold uppercase  text-[#b8903c]">
            Join Our Team
          </p>

          <h2 className="mt-5 text-4xl  text-[#16233d] md:text-5xl">
            Build your career in <br />
            capital markets.
          </h2>

          <div className="mt-8 h-[3px] w-16 bg-[#b8903c]" />

          <p className="mt-10 text-base leading-7 text-gray-500 max-w-[560px]">
            We are always looking for driven professionals who are passionate
            about structured finance, debt advisory, and investment banking. If
            you thrive in a deal-oriented environment and want to work on
            meaningful transactions, we'd love to hear from you.
          </p>
        </div>

        {/* Job Cards */}
        <div className="mt-20 grid grid-cols-1 gap-12 md:grid-cols-2 xl:grid-cols-3">
          {jobs.map((job, index) => (
            <div
              key={job.id}
              className={`relative ${
                index !== jobs.length - 1
                  ? "xl:border-r xl:border-gray-200 xl:pr-10"
                  : ""
              }`}
            >
              <span className="text-xs tracking-[3px] text-[#b8903c]">
                {job.id}
              </span>

              <h3 className="mt-6 text-2xl font-medium text-[#16233d]">
                {job.title}
              </h3>

              <p className="mt-6 text-sm leading-7 text-gray-500">
                {job.description}
              </p>

              <div className="mt-8 flex flex-wrap gap-3">
                {job.tags.map((tag) => (
                  <span
                    key={tag}
                    className="rounded bg-[#f5ebd2] px-4 py-2 text-xs font-semibold uppercase tracking-wide text-[#8d6b23]"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="mt-20 border-t border-gray-200 pt-10">
          <p className="text-sm text-gray-500">
            To apply or send a speculative profile, write to us at{" "}
            <Link
              href="mailto:info@ybcapital.in"
              className="font-medium text-[#b8903c] hover:underline"
            >
              info@ybcapital.in
            </Link>{" "}
            with the subject line{" "}
            <span className="italic text-[#6b7280]">Career – [Role Name]</span>.
          </p>
        </div>
      </div>
    </section>
  );
}
